import * as React from 'react';
import PropTypes from 'prop-types';
import { Table, TabbedCard, Tab } from 'tabler-react';
import dayjs from 'dayjs';
import i18n from '../../shared/i18n';

class AffiliateTable extends React.PureComponent {
  renderRecommendRow(bonus) {
    const statusMap = {
      CONFIRM: i18n.t('dash-aff-transfered'),
      UNCONFIRM: i18n.t('dash-aff-available'),
    };
    return (
      <Table.Row key={bonus._id}>
        <Table.Col> {statusMap[bonus.status]} </Table.Col>
        <Table.Col> {dayjs(bonus.paidAt).format('YYYY-MM-DD')} </Table.Col>
        <Table.Col>{bonus.userEmail}</Table.Col>
        <Table.Col>
          <strong> $ {bonus.affBonus} </strong>
        </Table.Col>
      </Table.Row>
    );
  }

  renderWithdrawRow(withdraw) {
    const map = {
      WITHDRAWED: i18n.t('dash-aff-withdrawed'),
      FAILED: `${i18n.t('dash-aff-failed')} [${withdraw.failedMessage}]`,
      CREATED: i18n.t('dash-aff-reviewing'),
    };

    const desc = map[withdraw.state] || i18n.t('dash-aff-unknown');
    return (
      <Table.Row key={withdraw._id}>
        <Table.Col>{dayjs(withdraw.createdAt).format('YYYY-MM-DD')}</Table.Col>
        <Table.Col>{withdraw.account}</Table.Col>
        <Table.Col>{withdraw.realAmount}</Table.Col>
        <Table.Col>{desc}</Table.Col>
      </Table.Row>
    );
  }

  renderHeader(titles) {
    return (
      <Table.Row>
        {titles.map(title => (
          <Table.Col>{title}</Table.Col>
        ))}
      </Table.Row>
    );
  }

  render() {
    const { bonuses, withdrawList, initialTab } = this.props;
    const titles = {
      recommend: [i18n.t('dash-aff-withdrawstatus'), i18n.t('dash-aff-buydate'), i18n.t('dash-aff-buyuser'), i18n.t('dash-aff-withdrawamount')],
      withdraw: [i18n.t('dash-aff-withdrawstart'), i18n.t('dash-aff-withdrawaccount'), i18n.t('dash-aff-submitmount'), i18n.t('dash-aff-submitstaus')],
    };
    const tabTitles = {
      bonus: i18n.t('dash-aff-referhistory'),
      withdrawList: i18n.t('dash-aff-withdrawhistory'),
    };
    return (
      <TabbedCard initialTab={initialTab}>
        <Tab title={tabTitles.bonus} className="test">
          <span className="aff-table-tag">{i18n.t('dash-aff-count')} {bonuses.length}</span>
          <Table className="card-table table-vcenter">
            <Table.Body>
              {this.renderHeader(titles.recommend)}
              {bonuses.map(bonus => this.renderRecommendRow(bonus))}
            </Table.Body>
          </Table>
        </Tab>
        <Tab title={tabTitles.withdrawList}>
          <Table className="card-table table-vcenter">
            <span className="aff-table-tag aff-tag-withdraw">
            {i18n.t('dash-aff-count')} {withdrawList.length}
            </span>
            <Table.Body>
              {this.renderHeader(titles.withdraw)}
              {withdrawList.map(withdraw => this.renderWithdrawRow(withdraw))}
            </Table.Body>
          </Table>
        </Tab>
      </TabbedCard>
    );
  }
}

AffiliateTable.propTypes = {
  bonuses: PropTypes.array,
  withdrawList: PropTypes.array,
  initialTab: PropTypes.string,
};

export default AffiliateTable;
